/**
 * CONVENTIONS §3: no console noise in production. `debug` and `info` are compiled out of the
 * production bundle by the `import.meta.env.DEV` guard; `warn` and `error` always survive so a
 * real failure is visible in the field.
 */

type Level = 'debug' | 'info' | 'warn' | 'error'

const PREFIX = '[disdis]'

function write(level: Level, scope: string, message: string, detail?: unknown) {
  const line = `${PREFIX} ${scope}: ${message}`
  if (level === 'error') {
    console.error(line, detail ?? '')
    return
  }
  if (level === 'warn') {
    console.warn(line, detail ?? '')
    return
  }
  if (import.meta.env.DEV) console.warn(line, detail ?? '')
}

export type Logger = {
  debug: (message: string, detail?: unknown) => void
  info: (message: string, detail?: unknown) => void
  warn: (message: string, detail?: unknown) => void
  error: (message: string, detail?: unknown) => void
}

export function log(scope: string): Logger {
  return {
    debug: (message, detail) => write('debug', scope, message, detail),
    info: (message, detail) => write('info', scope, message, detail),
    warn: (message, detail) => write('warn', scope, message, detail),
    error: (message, detail) => write('error', scope, message, detail),
  }
}

/** Turns anything thrown into a message, so a catch never swallows the reason. */
export function reason(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return JSON.stringify(error)
}
